import lodashIsEqual from "lodash/isEqual";
import {useCallback, useEffect, useMemo, useRef} from "react";
function useDeepCompareMemoize(value, isEqual = lodashIsEqual) {
  const ref = useRef();
  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}
export function useDeepCompareEffect(callback, dependencies, isEqual = lodashIsEqual) {
  useEffect(callback, [...useDeepCompareMemoize(dependencies, isEqual)]);
}
export function useDeepCompareCallback(callback, dependencies, isEqual = lodashIsEqual) {
  return useCallback(callback, [
    ...useDeepCompareMemoize(dependencies, isEqual)
  ]);
}
export function useDeepCompareMemo(callback, dependencies, isEqual = lodashIsEqual) {
  return useMemo(callback, [...useDeepCompareMemoize(dependencies, isEqual)]);
}
